import React, { useState } from "react";
import { useMediaQuery } from "react-responsive";
import emailjs from "emailjs-com";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";

const SocialMedia = () => {
  const isMobile = useMediaQuery({ query: "(max-width: 767px)" });

  const [formData, setFormData] = useState({
    name: "",
    companyName: "",
    mobile: "",
    email: "",
    inqueryType: "",
    details: "",
  });
  const [isSending, setIsSending] = useState(false);

  const isFormValid =
    formData.name &&
    formData.companyName &&
    formData.mobile &&
    formData.details &&
    formData.inqueryType &&
    formData.email;

  const [errors, setErrors] = useState({
    name: "",
    mobile: "",
    details: "",
  });

  const validateMobile = (mobile) => {
    const mobileRegex = /^[0-9]{11}$/;
    return mobileRegex.test(mobile);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setErrors({ ...errors, [name]: "" });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { name, mobile, details, companyName, email, inqueryType } = formData;

    if (!validateMobile(mobile)) {
      setErrors({ ...errors, mobile: "Invalid mobile number" });
      return;
    }

    setIsSending(true);

    try {
      const emailData = {
        name,
        mobile,
        details,
        companyName,
        email,
        inqueryType,
      };

      console.log("EmailJS Data:", emailData);

      emailjs
        .send(
          "service_ukwpswk",
          "template_qaps4ud",
          emailData,
          "eustvQeLOCU86kDQW"
        )
        .then(
          (response) => {
            console.log("Message sent successfully:", response);
            setIsSending(false);
            setFormData({
              name: "",
              mobile: "",
              details: "",
              inqueryType: "",
              companyName: "",
              email: "",
            });
          },
          (error) => {
            console.error("Failed to send message:", error);
            setIsSending(false);
          }
        );
    } catch (error) {
      console.error("Error uploading files:", error);
      setIsSending(false);
    }
  };

  return (
    <section className="webDesign page">
      {isMobile ? (
        <>
          <div className="webDesign-container">
            <div className="title">
              <h1>
                <span className="title-word">Social Media Management</span>
                Service
              </h1>
              <p>
                Services &gt;
                <span className="desc-word">
                  Social Media Management Service
                </span>
              </p>
              <p>
                At CS Lab, our Social Media Management Service is crafted to
                guide your product from concept to launch, ensuring a
                user-centered design that enhances engagement and functionality.
                Here’s how we bring your vision to life:
              </p>
            </div>
            <div className="box box-1">
              <div className="box-right">
                <div className="text-box">
                  <h1>1. Brainstorm</h1>
                  <div className="image-box">
                    <LazyLoadImage
                      src={require("../../../assets/blog-details-sec.jpg")}
                      alt="BrainStorm Picture"
                      effect="blur"
                    />
                  </div>
                  <p>
                    We engage in a detailed brainstorming session to explore and
                    define your product vision. Together, we dive deep into
                    ideas, ensuring alignment with your goals and objectives.
                    This collaborative process examines each concept thoroughly,
                    refining them through discussions and creative thinking.
                  </p>
                  <p>
                    By carefully analyzing and organizing these insights, we
                    create a clear and structured roadmap for development,
                    laying the groundwork for a smooth and successful execution
                    of the project.
                  </p>
                </div>
              </div>
            </div>
            <div className="box box-2">
              <div className="box-right">
                <div className="text-box">
                  <h1>2. Define</h1>
                  <div className="image-box">
                    <LazyLoadImage
                      src={require("../../../assets/Define.jpg")}
                      alt="Define Picture"
                      effect="blur"
                    />{" "}
                  </div>
                  <p>
                    Together, we outline the product’s objectives, target
                    audience, and core features. This collaborative approach
                    ensures that we understand your vision and requirements in
                    depth, allowing us to align our strategies with your
                    business goals.
                  </p>
                  <p>
                    We delve into market research and competitor analysis to
                    refine your product’s positioning and ensure it stands out.
                  </p>
                  <p>
                    By establishing a strong foundation for design, we set the
                    stage for a seamless and effective development process,
                    ensuring every detail is meticulously planned and executed.
                  </p>
                </div>
              </div>
            </div>
            <div className="box box-3">
              <div className="box-right">
                <div className="text-box">
                  <h1>3. Design</h1>
                  <div className="image-box">
                    <LazyLoadImage
                      src={require("../../../assets/blog-details-4.jpg")}
                      alt="Design Picture"
                      effect="blur"
                    />{" "}
                  </div>
                  <p>
                    Our team meticulously crafts wireframes and high-fidelity
                    designs, focusing not only on usability and aesthetics but
                    also on creating intuitive, seamless user journeys. This
                    process is highly collaborative, ensuring that every design
                    element aligns with your vision and brand identity.
                  </p>
                  <p>
                    We dive into user behavior analysis and industry best
                    practices to ensure your design is both functional and
                    visually appealing. By refining every detail, we create a
                    design that engages users, enhances their experience, and
                    positions your product for success in the market.
                  </p>
                </div>
              </div>
            </div>
            <div className="box box-4">
              <div className="box-right">
                <div className="text-box">
                  <h1>4. Test</h1>
                  <div className="image-box">
                    <LazyLoadImage
                      src={require("../../../assets/Test.jpg")}
                      alt="Test Picture"
                      effect="blur"
                    />{" "}
                  </div>
                  <p>
                    We conduct rigorous testing to ensure not only functionality
                    and usability but also design consistency across all devices
                    and platforms. Our testing process involves a range of
                    methods, including user testing, performance checks, and
                    cross-browser/device testing to identify and resolve any
                    potential issues.
                  </p>
                  <p>
                    By gathering real-time user feedback and analyzing
                    interactions, we ensure that your product is intuitive,
                    responsive, and meets the highest quality standards. This
                    thorough testing guarantees a seamless user experience,
                    regardless of the device or environment, and ensures your
                    product is ready for launch without any setbacks.
                  </p>
                </div>
              </div>
            </div>
            <div className="box box-5">
              <div className="box-right">
                <div className="text-box">
                  <h1>5. Launch</h1>
                  <div className="image-box">
                    <LazyLoadImage
                      src={require("../../../assets/Launch.jpg")}
                      alt="Launch Picture"
                      effect="blur"
                    />{" "}
                  </div>
                  <p>
                    Finally, we assist in deploying your product, ensuring a
                    smooth and successful transition from design to reality. Our
                    team works closely with you during the deployment phase,
                    handling all technical aspects, from server setup to
                    integration and configuration, to ensure a seamless launch.
                  </p>
                  <p>
                    We also provide post-launch support, monitoring performance
                    and gathering user feedback to make any necessary
                    adjustments. This ensures your product not only launches
                    smoothly but also operates efficiently from day one,
                    positioning it for long-term success in the market.
                  </p>
                </div>
              </div>
            </div>
            <div className="desc">
              <p>
                With CS Lab, every step is carefully tailored to make your
                product intuitive, engaging, and market-ready. We focus on
                user-centered designs and seamless experiences, ensuring your
                product aligns with your goals and stands out for long-term
                success.
              </p>
            </div>
            <div className="form-container">
              <div className="form-left">
                <div className="text-box">
                  <h1>
                    Bring your vision to life! Fill in your
                    <span className="title-word"> Contact </span>
                    details now, and let’s start elevating your brand!
                  </h1>
                </div>
              </div>
              <div className="form-right">
                <form onSubmit={handleSubmit}>
                  <div className="row-1">
                    <div className="input-box">
                      <input
                        name="name"
                        type="text"
                        placeholder="Name"
                        value={formData.name}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="input-box">
                      <input
                        name="companyName"
                        type="text"
                        placeholder="Company Name"
                        value={formData.companyName}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="row-2">
                    <div className="input-box">
                      <input
                        name="mobile"
                        type="text"
                        placeholder="Phone Number"
                        value={formData.mobile}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="row-3">
                    <div className="input-box">
                      <input
                        name="email"
                        type="email"
                        placeholder="Email"
                        value={formData.email}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="row-4">
                  <select
                      name="inqueryType"
                      value={formData.inqueryType}
                      onChange={handleChange}
                    >
                      <option value="">Inquiry Type</option>
                      <option value="UI/UX Design">UI/UX Design</option>
                      <option value="Graphic Design">Graphic Design</option>
                      <option value="SEO & SEM">SEO & SEM</option>
                      <option value="Video Editing">Video Editing</option>
                      <option value="Content Creation">Content Creation</option>
                      <option value="Social Media Management">
                        Social Media Management
                      </option>
                      <option value="Motion Graphics">Motion Graphics</option>
                      <option value="Paid Social Media Advertising">
                        Paid Social Media Advertising
                      </option>
                      <option value="Digital Marketing">
                        Digital Marketing
                      </option>
                      <option value="None of the above">
                        None of the above
                      </option>
                    </select>
                  </div>
                  <div className="row-5">
                    <div className="input-box">
                      <textarea
                        placeholder="Write your message here..."
                        name="details"
                        value={formData.details}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <button
                    className="btn"
                    type="submit"
                    disabled={!isFormValid || isSending}
                    style={{
                      opacity: isFormValid ? 1 : 0.5,
                      pointerEvents: isFormValid ? "auto" : "none",
                    }}
                  >
                    Send Message
                  </button>
                </form>
              </div>
            </div>
          </div>
        </>
      ) : (
        <>
          <div className="webDesign-container">
            <div className="title">
              <h1>
                <span className="title-word">Social Media Management</span>
                Service
              </h1>
              <p>
                Services &gt;
                <span className="desc-word">
                  Social Media Management Service
                </span>
              </p>
              <p>
                At CS Lab, our Social Media Management Service is crafted to
                guide your product from concept to launch, ensuring a
                user-centered design that enhances engagement and functionality.
                Here’s how we bring your vision to life:
              </p>
            </div>
            <div className="box box-1">
              <div className="box-left">
                <div className="image-box">
                  <LazyLoadImage
                    src={require("../../../assets/blog-details-sec.jpg")}
                    alt="BrainStorm Picture"
                    effect="blur"
                  />
                </div>
              </div>
              <div className="box-right">
                <div className="text-box">
                  <h1>1. Brainstorm</h1>
                  <p>
                    We engage in a detailed brainstorming session to explore and
                    define your product vision. Together, we dive deep into
                    ideas, ensuring alignment with your goals and objectives.
                    This collaborative process examines each concept thoroughly,
                    refining them through discussions and creative thinking.
                  </p>
                  <p>
                    By carefully analyzing and organizing these insights, we
                    create a clear and structured roadmap for development,
                    laying the groundwork for a smooth and successful execution
                    of the project.
                  </p>
                </div>
              </div>
            </div>
            <div className="box box-2">
              <div className="box-right">
                <div className="text-box">
                  <h1>2. Define</h1>
                  <p>
                    Together, we outline the product’s objectives, target
                    audience, and core features. This collaborative approach
                    ensures that we understand your vision and requirements in
                    depth, allowing us to align our strategies with your
                    business goals.
                  </p>
                  <p>
                    We delve into market research and competitor analysis to
                    refine your product’s positioning and ensure it stands out.
                  </p>
                  <p>
                    By establishing a strong foundation for design, we set the
                    stage for a seamless and effective development process,
                    ensuring every detail is meticulously planned and executed.
                  </p>
                </div>
              </div>
              <div className="box-left">
                <div className="image-box">
                  <LazyLoadImage
                    src={require("../../../assets/Define.jpg")}
                    alt="Define Picture"
                    effect="blur"
                  />
                </div>
              </div>
            </div>
            <div className="box box-3">
              <div className="box-left">
                <div className="image-box">
                  <LazyLoadImage
                    src={require("../../../assets/blog-details-4.jpg")}
                    alt="Design Picture"
                    effect="blur"
                  />
                </div>
              </div>
              <div className="box-right">
                <div className="text-box">
                  <h1>3. Design</h1>
                  <p>
                    Our team meticulously crafts wireframes and high-fidelity
                    designs, focusing not only on usability and aesthetics but
                    also on creating intuitive, seamless user journeys. This
                    process is highly collaborative, ensuring that every design
                    element aligns with your vision and brand identity.
                  </p>
                  <p>
                    We dive into user behavior analysis and industry best
                    practices to ensure your design is both functional and
                    visually appealing. By refining every detail, we create a
                    design that engages users, enhances their experience, and
                    positions your product for success in the market.
                  </p>
                </div>
              </div>
            </div>
            <div className="box box-4">
              <div className="box-right">
                <div className="text-box">
                  <h1>4. Test</h1>
                  <p>
                    We conduct rigorous testing to ensure not only functionality
                    and usability but also design consistency across all devices
                    and platforms. Our testing process involves a range of
                    methods, including user testing, performance checks, and
                    cross-browser/device testing to identify and resolve any
                    potential issues.
                  </p>
                  <p>
                    By gathering real-time user feedback and analyzing
                    interactions, we ensure that your product is intuitive,
                    responsive, and meets the highest quality standards. This
                    thorough testing guarantees a seamless user experience,
                    regardless of the device or environment, and ensures your
                    product is ready for launch without any setbacks.
                  </p>
                </div>
              </div>
              <div className="box-left">
                <div className="image-box">
                  <LazyLoadImage
                    src={require("../../../assets/Test.jpg")}
                    alt="Test Picture"
                    effect="blur"
                  />
                </div>
              </div>
            </div>
            <div className="box box-5">
              <div className="box-left">
                <div className="image-box">
                  <LazyLoadImage
                    src={require("../../../assets/Launch.jpg")}
                    alt="Launch Picture"
                    effect="blur"
                  />
                </div>
              </div>
              <div className="box-right">
                <div className="text-box">
                  <h1>5. Launch</h1>
                  <p>
                    Finally, we assist in deploying your product, ensuring a
                    smooth and successful transition from design to reality. Our
                    team works closely with you during the deployment phase,
                    handling all technical aspects, from server setup to
                    integration and configuration, to ensure a seamless launch.
                  </p>
                  <p>
                    We also provide post-launch support, monitoring performance
                    and gathering user feedback to make any necessary
                    adjustments. This ensures your product not only launches
                    smoothly but also operates efficiently from day one,
                    positioning it for long-term success in the market.
                  </p>
                </div>
              </div>
            </div>
            <div className="desc">
              <p>
                With CS Lab, every step is carefully tailored to make your
                product intuitive, engaging, and market-ready. We focus on
                user-centered designs and seamless experiences, ensuring your
                product aligns with your goals and stands out for long-term
                success.
              </p>
            </div>
            <div className="form-container">
              <div className="form-left">
                <div className="text-box">
                  <h1>
                    Bring your vision to life! Fill in your
                    <span className="title-word"> Contact </span>
                    details now, and let’s start elevating your brand!
                  </h1>
                </div>
              </div>
              <div className="form-right">
                <form onSubmit={handleSubmit}>
                  <div className="row-1">
                    <div className="input-box">
                      <input
                        name="name"
                        type="text"
                        placeholder="Name"
                        value={formData.name}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="input-box">
                      <input
                        name="companyName"
                        type="text"
                        placeholder="Company Name"
                        value={formData.companyName}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="row-2">
                    <div className="input-box">
                      <input
                        name="mobile"
                        type="text"
                        placeholder="Phone Number"
                        value={formData.mobile}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="row-3">
                    <div className="input-box">
                      <input
                        name="email"
                        type="email"
                        placeholder="Email"
                        value={formData.email}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="row-4">
                  <select
                      name="inqueryType"
                      value={formData.inqueryType}
                      onChange={handleChange}
                    >
                      <option value="">Inquiry Type</option>
                      <option value="UI/UX Design">UI/UX Design</option>
                      <option value="Graphic Design">Graphic Design</option>
                      <option value="SEO & SEM">SEO & SEM</option>
                      <option value="Video Editing">Video Editing</option>
                      <option value="Content Creation">Content Creation</option>
                      <option value="Social Media Management">
                        Social Media Management
                      </option>
                      <option value="Motion Graphics">Motion Graphics</option>
                      <option value="Paid Social Media Advertising">
                        Paid Social Media Advertising
                      </option>
                      <option value="Digital Marketing">
                        Digital Marketing
                      </option>
                      <option value="None of the above">
                        None of the above
                      </option>
                    </select>
                  </div>
                  <div className="row-5">
                    <div className="input-box">
                      <textarea
                        placeholder="Write your message here..."
                        name="details"
                        value={formData.details}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <button
                    className="btn"
                    type="submit"
                    disabled={!isFormValid || isSending}
                    style={{
                      opacity: isFormValid ? 1 : 0.5,
                      pointerEvents: isFormValid ? "auto" : "none",
                    }}
                  >
                    Send Message
                  </button>
                </form>
              </div>
            </div>
          </div>
        </>
      )}
    </section>
  );
};

export default SocialMedia;
